import { useState, useEffect,useCallback } from "react";
import { useSelector, useDispatch  } from "react-redux";
import {
  addTechnology,
  getTechnologys,
  getTechnology,
  editTechnology,
  deleteTechnology,
  getAllTechnologys,
} from "../../store/actions/technology_action";
import _debounce from "lodash/debounce";
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllTechnologys = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.technology);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
 
  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteTechnology(deleteEntry));
  }
    allQuery();
  }, [deleteEntry, pageNumber, window.location.search]);
  const allQuery = useCallback(
    _debounce(() => {
     
      dispatch(
        getTechnologys({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [
    data, setPageNumber, deleteBtnClicked
  ];
};

// Get Single Data
export const useSingleTechnology = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.technology);
  useEffect(() => {
    dispatch(getTechnology(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateTechnology = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.technology);
  const addData = async (data) => {
    await dispatch(addTechnology(data));
  };
  return [data, addData];
};
export const useUpdateTechnology = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.technology);
  const updateData = async (id, data) => {
    await dispatch(editTechnology(id, data));
  };
  return [updateData];
};

export const useSelectAllTechnology = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState("");
  const [value, setValue] = useState("");
  const data = useSelector((state) => state.technology);
  useEffect(() => {
    dispatch(getAllTechnologys({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};


export const useGetDropdownOptions = () => {
  //  const [client, setClientSearchField, setClientSearchValue] =
    // useSelectAllClient();
 
  const [dropdownOptions, setDropdownOptions] = useState({});
  // useEffect(() => {
  //   if (industry && industry.all_industrys) {
  //     const newData = industry.all_industrys.map((item) => {
  //       return { label: item.name, value: item.name };
  //     });
  //     setDropdownOptions({ ...dropdownOptions, industry: newData });
  //   }
  // }, [industry]);
  const loadOptions = async (inputValue, callback, field) => {
    // if (field == "parent_category") {
    //   await setCategorySearchField("name");
    //   await setCategorySearchValue(inputValue);
    //   callback(dropdownOptions.parent_category);
    // }
  };

 
  return [dropdownOptions,loadOptions  ];
};